/* eslint-disable react/no-array-index-key */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/aria-role */
import React, { useState } from 'react';
import {
  Modal, Fade, Typography, Backdrop,
} from '@material-ui/core';
import Cookies from 'js-cookie';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { userLogout } from '@shared/services/shareAuthenticationApi';
// style
import './UserAccountBan.css';

// ban images
import BanPermanently from '@assets/images/ban_and_lock/ban-perma.png';
import BanTemporarily from '@assets/images/ban_and_lock/ban-tempo.png';
import Envelope from '@assets/images/ban_and_lock/envelope.png';

import unsetSegmentIdentity from '@shared/utils/UnsetSegmentIdentity';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '9999',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    color: '#74777A',
    width: '100%',
    maxWidth: '580px',
    margin: '0 10px',
    padding: '115px 15px 68px',
    boxSizing: 'border-box',
    textAlign: 'center',
    position: 'relative',
    borderRadius: '15px',
    [theme.breakpoints.down('sm')]: {
      padding: '70px 15px',
      maxHeight: '98%',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '30px 15px',
    },
  },
}));

function UserAccountBan({ banModalStatus, userBanDetails }) {
  const [modalStatus, setModalStatus] = useState(banModalStatus);
  const modalClasses = useStyles();

  const closeBanModal = () => {
    setModalStatus(false);
    if (Cookies.get('token')) {
      const _userToken = Cookies.get('token');
      userLogout(_userToken)
        .then(((response) => {
          if (response.status === 200 && response.data.code === '200') {
            // Unset Segment Identity
            unsetSegmentIdentity();
            // remove token we set
            Cookies.remove('token');
            Cookies.remove('uid');
            // segment tracking
            if (process.env.REACT_APP_ON_SEGMENT === 'true') {
              const _eventName = 'Signed Out';
              window.analytics.track(_eventName, {});
            }
            window.location.reload();
          }
        }))
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const timestampToDate = (timestamp) => new Date(timestamp * 1000).toLocaleString('default', {
    month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit',
  });

  const renderViolations = () => (
    <ul className='violation-list'>
      {userBanDetails.data.violations.map((vltn, index) => (
        <React.Fragment key={index}>
          {vltn.sub_violation.length > 1
            ? vltn.sub_violation.map((sub, ndx) => (<li className='ban-list' key={ndx}>{sub}</li>))
            : <li className='ban-list' key={index}>{vltn.sub_violation}</li>}
        </React.Fragment>
      ))}
    </ul>
  );

  const renderBanMsg = () => {
    if (userBanDetails.data.ban_level === 'Permanent Ban') {
      return (
        <>
          <img src={BanPermanently} className='ban-image permanent' alt='permanent-ban-account-icon' />
          <Typography className='ban-title'>
            Your account (@
            {userBanDetails.data.username}
            ) has been permanently banned
          </Typography>

          <Typography className='ban-desc'>Your account is permanently banned due to:</Typography>
        </>
      );
    }
    return (
      <>
        <img src={BanTemporarily} className='ban-image' alt='temporary-ban-account-icon' />
        <Typography className='ban-title'>
          Your account (@
          {userBanDetails.data.username}
          ) has been temporarily suspended and will be restored on
          { timestampToDate(userBanDetails.data.ban_end)}
        </Typography>

        <Typography className='ban-desc'>
          Your account is suspended for
          { userBanDetails.data.duration }
          {' '}
          due to:
        </Typography>
      </>
    );
  };

  return (
    <Modal
      className={modalClasses.modal}
      open={modalStatus}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={modalStatus}>
        <div className={modalClasses.paper}>
          <div role='close-btn'>
            <CloseIcon className='close-ban-modal-icon' onClick={closeBanModal} />
          </div>
          <div className='top-modal-wrapper'>
            {renderBanMsg()}
            {renderViolations()}

            <Typography className='learn-more'>
              To learn more about Kumunity Guidelines, please visit
              {' '}
              <br />
              {' '}
              the
              <a href='https://kumu.zendesk.com/hc/en-us/articles/360025251411-Kumunity-Rules'> FAQS page</a>
            </Typography>
          </div>

          <div className='bottom-modal-wrapper'>
            <Typography>
              If you think your account was
              suspended by mistake, please contact us via email:
            </Typography>
            <div className='email-support'>
              <img src={Envelope} alt='envelope-icon' />
              <a href='mailto:support@kumu.ph'>support@kumu.ph</a>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}

export default UserAccountBan;
